import { render, staticRenderFns } from "./CreditLimit.vue?vue&type=template&id=196482e4&scoped=true&"
import script from "./CreditLimit.vue?vue&type=script&lang=js&"
export * from "./CreditLimit.vue?vue&type=script&lang=js&"
import style0 from "./CreditLimit.vue?vue&type=style&index=0&id=196482e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196482e4",
  null
  
)

export default component.exports